'use strict';
import { module } from '../app';
import * as _ from 'lodash';


module.factory('PrinterDocumentViewModel', ['documentsSvc', '$ionicLoading',
  function(documentsSvc, $ionicLoading) {
    function PrinterDocumentViewModel(modalInstance, modalService, document, printers) {
      let self = this;

      self.enabledPrinters = printers;
      self.printerName = '';
      self.document = document;

      self.cancelChanges = function() {
        modalInstance.remove();
      };

      self.init = function() {
      };

      self.print = function() {
        if (!self.printerName) {
          modalService.showAlert('Please select printer.');
          return;
        }
        documentsSvc.printDocument(self.document, self.printerName).then(() => {
          modalInstance.remove().then(() => {
            modalService.showAlert('Document sent to server printer.');
            self.document.onPrintedCallback && self.document.onPrintedCallback(self.printerName);
          });
        }, resp => {
          modalInstance.remove().then(() => {
            modalService.showErrorMessage(resp.data, resp.status);
          });
        });
      };

      self.init();
    }

    return PrinterDocumentViewModel;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/models/PrinterDocumentViewModel.js